import script from "./PriorHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PriorHeader.vue?vue&type=script&setup=true&lang=js"

import "./PriorHeader.vue?vue&type=style&index=0&id=7a2c716a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2c716a"]])

export default __exports__